// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 550 ? "ed48eaa7" : chunkId) + "." + {"146":"f39ac256d9557c42","550":"7a198a0a767778eb"}[chunkId] + ".js";
};